import client from './client'
import qs from 'qs'

export const doLogin = async (data) => {
  // ORDS api path: auth/doLogin
  return client.post(`${process.env.REACT_APP_AUTH_URL}oauth/getaccesstoken`, qs.stringify(data), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })
}

export const getAccessForgotPassword = async (data) => {
  // ORDS api path: user/sendPasswordCode
  return client.post(`${process.env.REACT_APP_AUTH_URL}forgot/forgotPassword`, qs.stringify(data), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })
}
export const sendResetMail = async (prm) => {
  // ORDS api path: user/sendResetMail
  return client.post(`${process.env.REACT_APP_AUTH_URL}forgot/resetMail`, qs.stringify(prm), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })
}
export const resetPasswordByUser = async (prm) => {
  // ORDS api path: user/resetPasswordByUser
  return client.post(`${process.env.REACT_APP_AUTH_URL}forgot/resetPasswordByUser`, qs.stringify(prm), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })
}


export const getUserInfo = () => {
  // console.log(`${process.env.REACT_APP_AUTH_URL}oauth/GetCurrentUser`)
  return client.get(`${process.env.REACT_APP_AUTH_URL}oauth/GetCurrentUser`, {
    params: {
      // P_REQUEST: getParams({ pi_message: prm })
    }
  })
}

export const setUserInfo =async ({key,value})=>{
  try {
    const result = await  client.post(`${process.env.REACT_APP_AUTH_URL}oauth/UpdateCurrentUser`, null, {
      // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      params: {
        key,value
      }
    })
    return result
  } catch (error) {
    console.log(error)
  }
  
}
export const logOutUser =async ()=>{
  try {
    const result = await  client.post(`${process.env.REACT_APP_AUTH_URL}oauth/LogoutCurrentUser`, null, {
      // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
     
    })
    return result
  } catch (error) {
    console.log(error)
  }
  
}